import { normalizeAppointmentSlotStart } from '@/utils/appointmentSlotStart'
import { normalizeVisitLmp } from '@/utils/visitLmp'
import { getApiV2Url } from '@/config/runtimeConfig'
import { buildAdminPatientQuery } from '@/utils/patientAdmin'
import { buildAdminVisitQuery } from '@/utils/visitAdmin'
import { allergySuggestionTop } from '@/utils/allergyAdmin'

const headers = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'x-functions-key': process.env.VUE_APP_BLOB_KEY
}
// Implement
export function PostLabFile ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'UploadLabFile',
    headers: headers,
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function getFile (param, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + `file?blob_name=${param.blob_name}&blob_type=${param.blob_type}&group_id=${param.group_id}`,
    headers: headers,
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function postFile (data, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + `file`,
    headers: headers,
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function getUserGroup ( param, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + `user-group?user_group=${param.user_group}`,
    headers: headers,
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}
export function UploadOtherMedicalFile ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'UploadOtherMedicalFile',
    headers: headers,
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetVisitDocument (visitId, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + `visit-document?visit_id=${visitId}`,
    headers: headers
    }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function DeleteVisitDocument (data, cb, errorCb) {
  window.axios({
    method: 'delete',
    url: getApiV2Url() + 'visit-document',
    headers: headers,
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetPatientDocument (rid, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + `patient-document?rid=${rid}`,
    headers: headers
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function DeletePatientDocument (data, cb, errorCb) {
  window.axios({
    method: 'delete',
    url: getApiV2Url() + 'patient-document',
    headers: headers,
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetUserGroup (cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'GetUserGroup',
    headers: headers
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function UploadStampImage ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'UploadStampImage',
    headers: headers,
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function UploadStampShareFile ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'UploadStampShareFile',
    headers: headers,
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetConsent (cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + 'consent',
    headers: { 'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostConsent ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'consent',
    headers: { 'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PutConsent ({ data }, cb, errorCb) {
  window.axios({
    method: 'put',
    url: getApiV2Url() + 'consent',
    headers: { 'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetSiteChatThread (param, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + 'chat-thread-site?group_id=' + param.groupId + '&rid= ' + param.rid + '&patient_id=' + param.patientId,
    headers: { 'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetVisitChatThread (param, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + 'chat-thread-site?group_id=' + param.groupId + '&rid= ' + param.rid + '&patient_id=' + param.patientId,
    headers: { 'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostVisitChatThread (data, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'chat-thread-visit',
    headers: { 'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function getSitesPromise (param) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + 'communication-service?group_id=' + param.groupId,
    headers: { 'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  })
}

export function patchSitePromise (param) {
  return window.axios({
    method: 'patch',
    url: getApiV2Url() + 'communication-service?group_id=' + param.groupId + '&id=' + param.id + '&_etag=' + param.etag,
    headers: { 'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  })
}

export function inviteUser (data, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'invite-user',
    headers: { 'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function getCommunicationUser () {
  return window.axios({
    method: 'post',
    url: getApiV2Url() + 'communication-user',
    headers: { 'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  })
}

export function getStockItemsTransac (param, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + 'item-stock-transac?stock_id=' + param.stock_id,
    headers: { 'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function getStockMovement (param, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + 'stock-movement?stock_id=' + param.stock_id,
    headers: { 'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

/**
 * GET Azure Function `stock` → sp_GetOrder (group_id, group_stock, matgroup, active).
 * Authorization: Bearer จาก axios interceptor; ต้องมี permission stock_get
 */
export function getStock (param, cb, errorCb) {
  const groupId = param.groupId ?? param.group_id
  const groupStock = param.groupStock ?? param.group_stock ?? 0
  const matRaw = param.matGroup ?? param.matgroup ?? '000'
  const matgroup = String(matRaw).padStart(3, '0').slice(0, 3)
  const activeRaw = param.active != null && param.active !== '' ? param.active : 'X'
  const active = String(activeRaw).toUpperCase().slice(0, 1)

  const q = new URLSearchParams()
  q.set('group_id', String(groupId))
  q.set('group_stock', String(groupStock))
  q.set('matgroup', matgroup)
  q.set('active', active)

  window.axios({
    method: 'get',
    url: `${getApiV2Url()}stock?${q.toString()}`,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY
    }
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

function restockRowsFromResponseBody (input) {
  let d = input
  if (d == null) return []
  if (typeof d === 'string') {
    try {
      d = JSON.parse(d)
    } catch (e) {
      return []
    }
  }
  if (Array.isArray(d)) return d
  if (typeof d !== 'object') return []

  if (typeof d.body === 'string') {
    try {
      d = JSON.parse(d.body)
    } catch (e) {
      return []
    }
  } else if (d.body != null && typeof d.body === 'object' && !Array.isArray(d.body)) {
    d = d.body
  }

  if (d.data != null && typeof d.data === 'object' && !Array.isArray(d.data)) {
    d = d.data
  }

  const rs = d.recordset != null ? d.recordset : d.Recordset
  if (Array.isArray(rs) && rs.length > 0) return rs
  if (rs != null && typeof rs.length === 'number' && rs.length > 0) {
    try {
      return Array.from(rs)
    } catch (e) {
      return []
    }
  }

  const rss = d.recordsets != null ? d.recordsets : d.Recordsets
  if (Array.isArray(rss) && rss[0] != null) {
    const first = rss[0]
    if (Array.isArray(first)) return first
    if (typeof first.length === 'number' && first.length > 0) {
      try {
        return Array.from(first)
      } catch (e) {
        return []
      }
    }
  }
  return []
}

function formatRestockLastUpdate (legacy) {
  const raw = legacy && (legacy.last_update || legacy.lastupdate)
  if (raw != null && String(raw).trim() !== '') {
    return String(raw).trim().slice(0, 20)
  }
  const s = new Date().toLocaleString('sv-SE', { timeZone: 'Asia/Bangkok' })
  return String(s).replace('T', ' ').slice(0, 20)
}

function mapLegacyRestockPostBody (body) {
  const b = body || {}
  const gid = Number(b.group_id)
  const gstock = b.group_stock != null && b.group_stock !== '' ? Number(b.group_stock) : gid
  return {
    active: String(b.active || '').toUpperCase().slice(0, 1),
    group_id: gid,
    group_stock: gstock,
    restock_id: Number(b.restock_id),
    order_amt: Number(b.purchase != null ? b.purchase : b.order_amt != null ? b.order_amt : 0),
    last_update: formatRestockLastUpdate(b),
    deplete_alert: Number(b.deplete_alert != null ? b.deplete_alert : 0),
    factor_multiply: Number(b.factor_multiply != null ? b.factor_multiply : 1),
    factor_plus: Number(b.factor_plus != null ? b.factor_plus : 0)
  }
}

function restockPostResponseForUi (data) {
  const ret = data != null ? data.returnValue : undefined
  const messages = {
    0: 'ดำเนินการแล้ว',
    1: 'อัปเดตการตั้งค่าการแจ้งเตือนแล้ว',
    2: 'สร้างรายการสั่งซื้อใหม่แล้ว',
    3: 'อัปเดตจำนวนสั่งซื้อแล้ว',
    4: 'หยุดแจ้งเตือนชั่วคราวแล้ว',
    5: 'ยุติการแจ้งเตือนและนโยบายแล้ว'
  }
  const message = messages[ret] != null
    ? messages[ret]
    : (ret != null ? `รหัสผลลัพธ์ ${ret}` : 'สำเร็จ')
  return {
    code: ret,
    message,
    returnValue: ret,
    recordset: data && data.recordset,
    recordsets: data && data.recordsets
  }
}

/**
 * GET Azure Function `restock` → RESTFUL_RESTOCKEST (group_id; วันที่ส่งจากเซิร์ฟเวอร์)
 */
export function getRestock (param, cb, errorCb) {
  const groupId = param.groupId ?? param.group_id
  window.axios({
    method: 'get',
    url: `${getApiV2Url()}restock?group_id=${encodeURIComponent(groupId)}`,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY
    }
  }).then(response => {
    const rows = restockRowsFromResponseBody(response.data)
    response.data = rows
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

/**
 * POST Azure Function `restock` → RESTFUL_RESTOCKESTPOST (+ legacy K/E/O ที่แปลงฝั่ง API)
 */
export function postRestock ({ body }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: `${getApiV2Url()}restock`,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY
    },
    data: mapLegacyRestockPostBody(body)
  }).then(response => {
    response.data = restockPostResponseForUi(response.data)
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function postTeleInvitation (data, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'tele-invitation',
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function getUsers (param, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + `user-acc?page_size=${param.page_size}&page_no=${param.page_no}&keyword=${param.keyword}&uuid=${param.uuid}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function getUserAD (param, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + `ad-username?uuid=${param.uuid}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function changePassword(data, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + `ad-password`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function createUser (data, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + `user-acc`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function updateUsername (data, cb, errorCb) {
  window.axios({
    method: 'patch',
    url: getApiV2Url() + `ad-username`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}


export function updateUser (data, cb, errorCb) {
  window.axios({
    method: 'patch',
    url: getApiV2Url() + `user-acc`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function getItemMaster (param, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + `item_master?page_size=${param.page_size}&page_no=${param.page_no}&keyword=${param.keyword}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function postItemMaster (data, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + `item_master`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function patchItemMaster (data, cb, errorCb) {
  window.axios({
    method: 'patch',
    url: getApiV2Url() + `item_master`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function getDrugGroup (cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + `drug_group`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function getRefMatgroup (cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + `ref_matgroup`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function getItemBun (cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + `item_bun`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function getLineKey(data, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + `line-verify`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function searchPatient (param) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `patient?keyword=${param.keyword}&group_id=${param.group_id}&sortBy=${param.sortBy}&sortDesc=${param.sortDesc}&page=${param.page}&itemsPerPage=${param.itemsPerPage}${(param.rid ? `&rid=${param.rid}` : '')}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  })
}

export function searchAdminPatients (param) {
  const query = buildAdminPatientQuery(param)
  const q = new URLSearchParams()
  Object.keys(query).forEach((key) => {
    if (query[key] === undefined || query[key] === null || query[key] === '') return
    q.set(key, String(query[key]))
  })
  const qs = q.toString()
  return window.axios({
    method: 'get',
    url: getApiV2Url() + 'patients' + (qs ? `?${qs}` : ''),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY
    }
  })
}

export function createAdminPatient (data) {
  return window.axios({
    method: 'post',
    url: getApiV2Url() + 'patients',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY
    },
    data: data
  })
}

export function updateAdminPatient (data) {
  return window.axios({
    method: 'patch',
    url: getApiV2Url() + 'patients',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY
    },
    data: data
  })
}
/**
 * GET /api/visits → sp_GetVisitRecordsAdmin.
 * Path is not under /admin (Azure Functions reserves that prefix).
 * Bearer comes from the axios interceptor; role must match permission (default ADMIN).
 * Do not send reader_id — the API takes it from JWT extension_SystemID.
 */
export function searchAdminVisits (param) {
  const query = buildAdminVisitQuery(param)
  const q = new URLSearchParams()
  Object.keys(query).forEach((key) => {
    if (query[key] === undefined || query[key] === null || query[key] === '') return
    q.set(key, String(query[key]))
  })
  const qs = q.toString()
  return window.axios({
    method: 'get',
    url: getApiV2Url() + 'visits' + (qs ? `?${qs}` : ''),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY
    }
  })
}

/**
 * GET /api/visits/{visit_id}/orders.
 * visit_id is a path integer greater than 0. Bearer comes from the interceptor.
 */
export function getAdminVisitOrders (visitId) {
  const id = Number(visitId)
  return window.axios({
    method: 'get',
    url: getApiV2Url() + 'visits/' + encodeURIComponent(id) + '/orders',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY
    }
  })
}

/**
 * GET /api/allergies → sp_GetPatientAllergies.
 * Pending rows only (alg_approve is not 1), newest last_update first.
 * Bearer role must be ADMIN. Do not send user_id.
 */
export function getAdminAllergies () {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + 'allergies',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY
    }
  })
}

/**
 * GET /api/allergies/{alg_id}/suggestions?top=5
 * Read-only. top defaults to 5 and is limited to 1–20.
 */
export function getAdminAllergySuggestions (algId, top = 5) {
  const id = Number(algId)
  const limit = allergySuggestionTop(top)
  return window.axios({
    method: 'get',
    url: getApiV2Url() + 'allergies/' + encodeURIComponent(id) + '/suggestions?top=' + limit,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY
    }
  })
}

/**
 * PATCH /api/allergies → sp_PatchPatientAllergy.
 * user_id comes from JWT extension_SystemID.
 */
export function patchAdminAllergy (data) {
  return window.axios({
    method: 'patch',
    url: getApiV2Url() + 'allergies',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY
    },
    data
  })
}

/**
 * POST /api/orders/{order_id}/return. No body.
 * Writer id comes from JWT extension_SystemID.
 */
export function returnAdminOrder (orderId) {
  const id = Number(orderId)
  return window.axios({
    method: 'post',
    url: getApiV2Url() + 'orders/' + encodeURIComponent(id) + '/return',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY
    }
  })
}

/**
 * PATCH /api/orders/{order_id}
 * Body is only { quantity }. The API recalculates price_stamp, price_base, and visit ser_amt.
 */
export function patchAdminOrderQuantity (orderId, quantity) {
  const id = Number(orderId)
  return window.axios({
    method: 'patch',
    url: getApiV2Url() + 'orders/' + encodeURIComponent(id),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY
    },
    data: { quantity: Number(quantity) }
  })
}

export function getVisitRecords (param) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `visit?rid=${param.rid}&group_id=${param.group_id}&sortBy=${param.sortBy}&sortDesc=${param.sortDesc}&page=${param.page}&itemsPerPage=${param.itemsPerPage}&per_status_list=${param.per_status_list}&per_date=${param.per_date}${param.user_id !== undefined ? `&user_id=${param.user_id}` : ''}${(param.user_group ? `&user_group=${param.user_group}` : '')}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  })
}

export function searchPatientAsync (param,  cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + `patient?keyword=${param.keyword}&group_id=${param.group_id}&sortBy=${param.sortBy}&sortDesc=${param.sortDesc}&page=${param.page}&itemsPerPage=${param.itemsPerPage}${(param.rid ? `&rid=${param.rid}` : '')}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function createPatient (data) {
  return window.axios({
    method: 'post',
    url: getApiV2Url() + `patient`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  })
}

export function updatePatient (data) {
  return window.axios({
    method: 'patch',
    url: getApiV2Url() + `patient`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  })
}

export function validateCitizenId (param) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `validateCitizenId?patient_id=${param.patient_id}&group_id=${param.group_id}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  })  
}

export function validateEmployee (param) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `validateEmployee?record_id=${param.record_id}&group_id=${param.group_id}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  })  
}

export function getQueueConfig (param) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `queue-settings?group_id=${param.group_id}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  })  
}

export function updateQueueConfig (data, cb, errorCb) {
  window.axios({
    method: 'patch',
    url: getApiV2Url() + `queue-settings`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function callQueue (data, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + `queue`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

export function getCurrentQueue (param) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `queue?group_id=${param.group_id}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  })  
}

export function getProviderQueue (param) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `provider?group_id=${param.group_id}&type=${param.type}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  })  
}

export function verifyInsurance (param) {
  const query = new URLSearchParams({
    group_id: String(param.group_id ?? ''),
    patient_id: String(param.patient_id ?? ''),
    record_id: String(param.record_id ?? ''),
    com_code: String(param.company_code ?? ''),
  })

  if (param.first_name_th != null && param.first_name_th !== '') {
    query.set('first_name_th', String(param.first_name_th))
  }
  if (param.last_name_th != null && param.last_name_th !== '') {
    query.set('last_name_th', String(param.last_name_th))
  }

  return window.axios({
    method: 'get',
    url: getApiV2Url() + `verify-insurance?${query.toString()}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  })  
}

export function getAllergyInfo (param) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `allergy?rid=${param.rid}&page=${param.page}&itemsPerPage=${param.itemsPerPage}&alg_approve=1&alg_stage=A`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  })  
}

export function getMedicineInfo (param) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `medicine?rid=${param.rid}&page=${param.page}&itemsPerPage=${param.itemsPerPage}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
  })   
}

export function getLabOrder (param) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `lab-order?${param.rid ? `rid=${param.rid}&` : ''}${param.page ? `page=${param.page}&` : ''}${param.page_size ? `page_size=${param.page_size}&` : ''}${param.sort_by ? `sort_by=${param.sort_by}&` : ''}${param.sort_desc !== undefined && param.sort_desc !== null ? `sort_desc=${param.sort_desc}&` : ''}${param.visit_id ? `visit_id=${param.visit_id}` : ''}`.replace(/&$/, ''),
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
    })
}

export function getLabResult (param) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `lab-result?rid=${param.rid}${param.startDate ? `&startDate=${param.startDate}` : ''}${param.endDate ? `&endDate=${param.endDate}` : ''}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
    }) 
} 

export function getVitalSign (param) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `vitalsign?rid=${param.rid}${param.startDate ? `&startDate=${param.startDate}` : ''}${param.endDate ? `&endDate=${param.endDate}` : ''}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
    }) 
}

export function getGroups (){
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `groups`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
    })
}

export function getReports () {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `reports`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
    })
}

export function getPages(){
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `pages`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
    })
}

export function getCompanies(param){
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `companies?group_id=${param.group_id}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
    })
}

export function getLabels(param){
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `label?group_stock=${param.group_stock}&visit_id=${param.visit_id}&order_id_list=${param.order_id_list}&transfer_dt=${param.transfer_dt}&per_status=${param.per_status}&order_status_list=${param.order_status_list}`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY }
    })
}

export function postLabelStatus(data, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + `label-status`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}

/** Merge print/email status. Key is rec_id + group_id — do not send visit_id. */
export function postDocumentStatus (data, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'document-status',
    headers: headers,
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => errorCb(error))
}


/**
 * Comma-separated node ids for GET /api/fast-track (max 500).
 * Accepts an array or a legacy pipe/comma string. Does not send user_id.
 */
export function formatFastTrackNodeList (raw) {
  if (raw == null || raw === '') return ''
  const parts = (Array.isArray(raw) ? raw : String(raw).split(/[,|]/))
    .map(part => String(part).trim())
    .filter(part => /^[1-9]\d*$/.test(part))
  let joined = ''
  for (let i = 0; i < parts.length; i++) {
    const next = joined ? `${joined},${parts[i]}` : parts[i]
    if (next.length > 500) break
    joined = next
  }
  return joined
}

/**
 * GET /api/fast-track → sp_GetFastTrackOrder.
 * Visit snapshot + recommended orders. Not the create-visit POST.
 * Bearer comes from the axios interceptor. Do not send user_id.
 * group_id is included only when the caller supplies one (JWT may already have it).
 */
export function getFastTrack (param = {}) {
  const rid = Number(param.rid)
  const q = new URLSearchParams()
  q.set('rid', String(rid))

  const nodeList = formatFastTrackNodeList(param.nodeList ?? param.node_list)
  if (nodeList) q.set('node_list', nodeList)

  const lmpRaw = param.lmp
  const lmp = lmpRaw == null || String(lmpRaw).trim() === ''
    ? '0'
    : String(lmpRaw).trim().slice(0, 10)
  q.set('lmp', lmp)

  const groupId = Number(param.groupId ?? param.group_id)
  if (Number.isFinite(groupId) && groupId > 0) {
    q.set('group_id', String(groupId))
  }

  const lastUpdate = param.lastUpdate ?? param.last_update
  if (lastUpdate != null && String(lastUpdate).trim() !== '') {
    q.set('last_update', String(lastUpdate).trim().slice(0, 20))
  }

  return window.axios({
    method: 'get',
    url: `${getApiV2Url()}fast-track?${q.toString()}`,
    headers: {
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
      'x-functions-key': process.env.VUE_APP_BLOB_KEY
    }
  })
}

export function createFastTrack(data, idempotencyKey) {
  return window.axios({
    method: 'post',
    url: getApiV2Url() + `fast-track`,
    headers: { 'Content-Type': 'application/json',
    'Accept': 'application/json',
    'idempotency-key': idempotencyKey,
    'x-functions-key': process.env.VUE_APP_BLOB_KEY },
    data: data
  })
}

export function getVaccinated (param) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `vaccinated?rid=${param.rid || ''}&sortBy=${param.sortBy || 'vaccined_id'}&sortDesc=${param.sortDesc || false}&page=${param.page || 1}&itemsPerPage=${param.itemsPerPage || 10}`,
    headers: headers
  })
}

export function postVaccinated (data) {
  return window.axios({
    method: 'post',
    url: getApiV2Url() + 'vaccinated',
    headers: headers,
    data: data
  })
}

export function patchVaccinated (data) {
  return window.axios({
    method: 'patch',
    url: getApiV2Url() + 'vaccinated',
    headers: headers,
    data: data
  })
}

export function deleteVaccinated (data) {
  return window.axios({
    method: 'delete',
    url: getApiV2Url() + 'vaccinated',
    headers: headers,
    data: data
  })
}

export function getVaccineItems () {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `vaccine-items`,
    headers: headers,
  })
}

export function getTrasferGroup(param){
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `transfer-group?group_id=${param.group_id}`,
    headers: headers,
  })
} 

export function getItemStock(param){
  const groupStock = param.group_stock
  const groupId = param.group_id != null ? param.group_id : groupStock
  const policy = param.policy === false || param.policy === 'false' ? 'false' : 'true'
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `item-stock?group_id=${groupId}&group_stock=${groupStock}&policy=${policy}`,
    headers: headers,
  })
} 

export function postBox(data){
  return window.axios({
    method: 'post',
    url: getApiV2Url() + `box`,
    headers: headers,
    data: data
  })
}

// ─── Visit Tags ────────────────────────────────────────────

/**
 * ดึง Tag Master ทั้งหมดของ Group
 * @param {{ group_id: number, activeOnly?: number }} param
 */
export function getTagsByGroup (param, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + `visit-tags?group_id=${param.group_id}&activeOnly=${param.activeOnly ?? 1}`,
    headers: headers,
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

/**
 * สร้างหรืออัปเดต Tag Master
 * @param {{ data: { group_id: number, tag_code: string, tag_name: string, tag_color?: string, is_active?: boolean } }} param
 */
export function upsertTag ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + `visit-tags`,
    headers: headers,
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

/**
 * ดึง Tags ที่กำหนดให้กับ Visit
 * @param {{ visit_id: number, group_id: number }} param
 */
export function getVisitTags (param, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + `visit/${param.visit_id}/tags?group_id=${param.group_id}`,
    headers: headers,
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

/**
 * กำหนด Tags ให้กับ Visit (Replace ชุดทั้งหมด)
 * @param {{ data: { visit_id: number, group_id: number, tag_ids: number[] } }} param
 */
export function setVisitTags ({ data }, cb, errorCb) {
  window.axios({
    method: 'put',
    url: getApiV2Url() + `visit/${data.visit_id}/tags?group_id=${data.group_id}`,
    headers: headers,
    data: { tag_ids: data.tag_ids }
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

/**
 * RESTFUL_INSURESEARCH via Functions app (insurance endpoint).
 * @param {{ policyNo?: string, rid?: number, groupId: number }} param
 */
export function getInsurance ({ policyNo = '', rid = 0, groupId }) {
  const insurancePolicyNo = encodeURIComponent(policyNo != null ? String(policyNo) : '')
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `insurance?insurance_policy_no=${insurancePolicyNo}&rid=${rid}&group_id=${groupId}`,
    headers: headers,
  })
}

/**
 * RESTFUL_DOCSEARCH (+ page_ele) via Functions app.
 * Accepts query-shaped names (class_id, …) or camelCase aliases (classId, …).
 * @param {{
 *   class_id?: number, classId?: number,
 *   subclass_id?: number, subclassId?: number,
 *   rid?: number,
 *   rec_id?: number, recId?: number,
 *   group_id?: number, groupId?: number,
 *   visit_id?: number, visitId?: number
 * }} [param]
 */
export function getDocument (param = {}) {
  const classId = param.class_id ?? param.classId ?? 0
  const subclassId = param.subclass_id ?? param.subclassId ?? 0
  const rid = param.rid ?? 0
  const recId = param.rec_id ?? param.recId ?? 0
  const groupId = param.group_id ?? param.groupId ?? 0
  const visitId = param.visit_id ?? param.visitId ?? 0
  return window.axios({
    method: 'get',
    url: getApiV2Url() + `document?class_id=${classId}&subclass_id=${subclassId}&rid=${rid}&rec_id=${recId}&group_id=${groupId}&visit_id=${visitId}`,
    headers: headers,
  })
}

/**
 * GET Azure Function `sendPDF` — generate PDF for doc and email (recipient configured server-side).
 * Used by RHCF prescription (doc_id / subclass 17) → ramatelemeds@gmail.com
 * @param {{ data: { doc_id: number, visit_id: number } }} param
 */
export function sendPDF ({ data }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + `sendPDF?doc_id=${data.doc_id}&visit_id=${data.visit_id}`,
    headers: headers
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

/**
 * เวร — endpoint duties (Azure Function)
 * GET ?start_dt=&end_dt= → sp_GetDuties (JSON)
 * POST → sp_PostDuties (JSON recordset { success, message } หรือ legacy text/plain)
 */
export function GetDuties ({ start_dt, end_dt }, cb, errorCb) {
  const q =
    '?start_dt=' +
    encodeURIComponent(start_dt) +
    '&end_dt=' +
    encodeURIComponent(end_dt)
  window.axios({
    method: 'get',
    url: getApiV2Url() + 'duties' + q,
    headers: headers
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostDuties ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'duties',
    headers: headers,
    data: data || {},
    transformResponse: [(payload) => {
      if (payload == null || payload === '') return payload
      if (typeof payload === 'object') return payload
      const s = String(payload).trim()
      if (s.startsWith('{') || s.startsWith('[')) {
        try {
          return JSON.parse(s)
        } catch {
          return payload
        }
      }
      return payload
    }]
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PutDuties ({ data }, cb, errorCb) {
  window.axios({
    method: 'put',
    url: getApiV2Url() + 'duties',
    headers: headers,
    data: data || {}
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

/** --- Duty workflow (docs/duty-frontend-knowledge.md) GET/POST JSON --- */

export function GetDutyTransferCandidates ({ ot_id: otId }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + 'duty/transfer/candidates?ot_id=' + encodeURIComponent(otId),
    headers: headers
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetDutyExchangeCandidates ({ ot_id: otId }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + 'duty/exchange/candidates?ot_id=' + encodeURIComponent(otId),
    headers: headers
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetDutyPending (cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + 'duty/pending',
    headers: headers
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostDutyTransferSubmit ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'duty/transfer/submit',
    headers: headers,
    data: data || {}
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostDutyTransferConfirm ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'duty/transfer/confirm',
    headers: headers,
    data: data || {}
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostDutyExchangeSubmit ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'duty/exchange/submit',
    headers: headers,
    data: data || {}
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostDutyExchangeConfirm ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'duty/exchange/confirm',
    headers: headers,
    data: data || {}
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostDutyRequestCancel ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'duty/request/cancel',
    headers: headers,
    data: data || {}
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostDutyRequestReject ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV2Url() + 'duty/request/reject',
    headers: headers,
    data: data || {}
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

/** --- Appointment queue (docs/appointment-frontend-knowledge.md) staff paths --- */

/**
 * แปลงค่าตัวเลข optional สำหรับ body appointment (null เมื่อว่าง)
 * @param {*} v
 * @returns {number|null}
 */
function pickOptionalAppointmentNumber (v) {
  if (v === '' || v === null || v === undefined) return null
  const n = Number(v)
  return Number.isFinite(n) ? n : null
}

/**
 * ฟิลด์ขยายสำหรับ POST จอง/walk-in จาก slot และ LIFF — ตาม docs/appointment-frontend-store-update.md
 * ไม่รวม cc_note / ot_id / slot_start / rid / is_tele / enc_serv (ให้ผู้เรียกใส่แยก)
 * @param {object|null|undefined} vital — รูปแบบใกล้เคียง PatientService.vital / VitalSign
 * @returns {object}
 */
export function buildAppointmentVisitExtension (vital) {
  if (!vital || typeof vital !== 'object') return {}
  const trimOrNull = (s) => {
    if (s == null || s === '') return null
    const t = String(s).trim()
    return t || null
  }
  const lmpCode = normalizeVisitLmp(vital.lmp)
  const ext = {
    per_status: '1',
    visit_note: trimOrNull(vital.visit_note),
    lmp: lmpCode === '' ? null : lmpCode,
    sbp: pickOptionalAppointmentNumber(vital.sbp),
    dbp: pickOptionalAppointmentNumber(vital.dbp),
    pulse: pickOptionalAppointmentNumber(vital.pulse),
    resp: pickOptionalAppointmentNumber(vital.resp),
    osat: pickOptionalAppointmentNumber(vital.osat),
    temp: pickOptionalAppointmentNumber(vital.temp),
    weight: pickOptionalAppointmentNumber(vital.weight),
    height: pickOptionalAppointmentNumber(vital.height),
    bmi: pickOptionalAppointmentNumber(vital.bmi)
  }
  const ser = pickOptionalAppointmentNumber(vital.ser_amt)
  if (ser !== null) ext.ser_amt = ser
  const ts = trimOrNull(vital.transfer_stamp)
  if (ts != null) ext.transfer_stamp = ts
  return ext
}

/**
 * GET /appointment/slots?ot_id=
 * @param {number|string} otId
 * @returns {Promise<Array>} slot rows
 */
export function getAppointmentSlots (otId) {
  return window.axios({
    method: 'get',
    url: getApiV2Url() + 'appointment/slots?ot_id=' + encodeURIComponent(otId),
    headers: headers
  }).then(res => {
    const body = res.data
    if (body && body.success && Array.isArray(body.data)) return body.data
    if (body && Array.isArray(body.data)) return body.data
    throw new Error(body && body.message ? body.message : 'ไม่สามารถโหลด slot ได้')
  })
}

/**
 * POST /appointment/reserved/create
 * @param {object} payload ตาม docs/appointment-frontend-store-update.md (ot_id, slot_start, rid, vitals, visit_note, …)
 * @returns {Promise<object>} data from API
 * On 400/404/409: rejected Error with .code, .status (see appointment-http mapping)
 */
function normalizeAppointmentCreateError (err) {
  const res = err.response
  if (!res || ![400, 404, 409].includes(res.status)) return err
  const d = res.data || {}
  const msg = d.message || err.message || 'จองไม่สำเร็จ'
  return Object.assign(new Error(msg), { code: d.code, status: res.status })
}

function postAppointmentSlotVisitCreate (pathSuffix, payload) {
  const data = { ...payload }
  if (data.slot_start != null && data.slot_start !== '') {
    const normalized = normalizeAppointmentSlotStart(data.slot_start)
    if (normalized) data.slot_start = normalized
  }
  return window.axios({
    method: 'post',
    url: getApiV2Url() + pathSuffix,
    headers: headers,
    data
  }).then(res => {
    const body = res.data
    if (body && body.success) return body.data
    throw Object.assign(new Error(body && body.message ? body.message : 'จองไม่สำเร็จ'), { code: body && body.code })
  }).catch(err => {
    const normalized = normalizeAppointmentCreateError(err)
    if (normalized.status) return Promise.reject(normalized)
    return Promise.reject(err)
  })
}

export function postAppointmentReservedCreate (payload) {
  return postAppointmentSlotVisitCreate('appointment/reserved/create', payload)
}

/**
 * POST /appointment/walkin/create-from-slot (staff)
 * Body เดียวกับ reserved/create — ตาม docs/appointment-frontend-knowledge.md
 * @param {object} payload
 * @returns {Promise<object>}
 */
export function postAppointmentWalkinCreateFromSlot (payload) {
  return postAppointmentSlotVisitCreate('appointment/walkin/create-from-slot', payload)
}

/**
 * POST /appointment/walkin/create-manual (staff)
 * ตารางไม่แบ่งช่วงเวลา (FCFS) — ระบุ per_date เอง ไม่ใช้ slot_start
 * @param {object} payload group_id, user_id, per_date, rid, …
 * @returns {Promise<object>}
 */
export function postAppointmentWalkinCreateManual (payload) {
  const data = { ...payload }
  if (data.per_date != null && data.per_date !== '') {
    const normalized = normalizeAppointmentSlotStart(data.per_date)
    if (normalized) data.per_date = normalized
  }
  return window.axios({
    method: 'post',
    url: getApiV2Url() + 'appointment/walkin/create-manual',
    headers: headers,
    data
  }).then(res => {
    const body = res.data
    if (body && body.success) return body.data
    throw Object.assign(new Error(body && body.message ? body.message : 'จองไม่สำเร็จ'), { code: body && body.code })
  }).catch(err => {
    const normalized = normalizeAppointmentCreateError(err)
    if (normalized.status) return Promise.reject(normalized)
    return Promise.reject(err)
  })
}